import axios from 'axios';

const translateIds = (data) => axios.post('/integrations/internal/translate_ids', data);

export default {
  translateIds,
};
